import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withRouter, NavLink, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {signoutUser} from '../../Auth/actions';
import {toggleDrawer, switchDrawer} from '../../Layout/actions';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CloseIcon from '@material-ui/icons/Close';
import routes from '../../../app/router/routes';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_header';

class HeaderNavigation extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    toggleDrawer = (drawer, open) => (e) => {
        e.preventDefault();

        this.props.toggleDrawer(drawer, open);
    };

    switchDrawer = (drawerToClose, drawerToopen) => (e) => {
        e.preventDefault();

        this.props.switchDrawer(drawerToClose, drawerToopen);
    };

    showNavigationDrawer = (e) => {
        const currentPath = this.props.location.pathname;

        if (currentPath.includes('/dashboard/')) {
            this.props.toggleDrawer('dashboard', true);
        } else {
            this.props.toggleDrawer('navigation', true);
        }
    };

    handleClickSignout = e => {
        e.preventDefault();

        this.props.signoutUser();
    };

    /**
     * Because the "List" navigation menu has a parent div with an onClick event to toggleDrawer(),
     * we need to use this method for external link.
     *
     * @param url
     * @returns {Function}
     */
    handleExternalLink = (url) => e => {
        e.preventDefault();

        //window.location.replace(url);
        let win = window.open(url, '_blank');
        win.focus();
    };

    render() {
        const {isAuthenticated} = this.props.auth;

        const menuItems = (
            <Fragment>
                <List component="nav"
                      subheader={
                          <ListSubheader component="div" className="top clearfix">
                              <Button size="large" className="btnCloseDrawer">
                                  <span><Translate id="header_navigation.fermer" /></span>
                                  <CloseIcon />
                              </Button>
                          </ListSubheader>
                      }>
                    <ListItem component={props => <NavLink to="/" exact {...props} />} button>
                        <Translate>
                            {({ translate }) => <ListItemText primary={translate('header_navigation.accueil')} />}
                        </Translate>
                    </ListItem>
                    <ListItem component={props => <NavLink to={this.props.translate('routes.schools')} {...props} />} button>
                        <Translate>
                            {({ translate }) => <ListItemText primary={translate('header_navigation.annuaire_ecoles')} />}
                        </Translate>
                    </ListItem>
                    <ListItem className="hassubmenu">
                        <ul>
                            <li><span><Translate id="header_navigation.culturel" /></span></li>
                            <ul className="submenu">
                                <ListItem component={props => <NavLink to={this.props.translate('routes.institutions')} {...props} />} button>
                                    <Translate>
                                        {({ translate }) => <ListItemText primary={translate('header_navigation.institutions')} />}
                                    </Translate>
                                </ListItem>
                                <ListItem component={props => <NavLink to={this.props.translate('routes.events')} {...props} />} button>
                                    <Translate>
                                        {({ translate }) => <ListItemText primary={translate('header_navigation.evenement')} />}
                                    </Translate>
                                </ListItem>
                                <ListItem component={props => <NavLink to={this.props.translate('routes.page_details').replace(':slug', this.props.translate('header_navigation.collaboration_lien'))} {...props} />} button>
                                    <Translate>
                                        {({ translate }) => <ListItemText primary={translate('header_navigation.collaboration')} />}
                                    </Translate>
                                </ListItem>
                            </ul>
                        </ul>
                    </ListItem>
                    <ListItem component={props => <NavLink to={this.props.translate('routes.about')} exact {...props} />} button>
                        <Translate>
                            {({ translate }) => <ListItemText primary={translate('header_navigation.apropos')} />}
                        </Translate>
                    </ListItem>
                    <ListItem component={props => <NavLink to={this.props.translate('routes.contact')} exact {...props} />} button>
                        <Translate>
                            {({ translate }) => <ListItemText primary={translate('header_navigation.contact')} />}
                        </Translate>
                    </ListItem>
                    {isAuthenticated && (
                        <ListItem component={props => <div data-type="button" {...props}>{ props.children }</div>} onClick={this.switchDrawer('navigation', 'dashboard')} button>
                            <Translate>
                                {({ translate }) => <ListItemText primary={translate('header_navigation.mon_espace')} />}
                            </Translate>
                        </ListItem>
                    )}
                    <ListItem component={props => <a href="https://www.ifp-ge.ch/" title="IFP" target="_blank" onClick={this.handleExternalLink('https://www.ifp-ge.ch/')} {...props}>{ props.children }</a>} button>
                        <Translate>
                            {({ translate }) => <ListItemText primary={translate('header_navigation.site_ifp')} />}
                        </Translate>
                    </ListItem>
                </List>
            </Fragment>
        );

        return (
            <div className="menu menu-button">
                 <Button size="large" className="btnNavigationDrawer" onClick={this.showNavigationDrawer}>
                    <Switch>
                        {routes.map((route, index) => {
                            if (typeof route.sidebar === 'string' || route.sidebar instanceof String) {
                                //let sidebarLabel = this.props.translate(route.sidebar);
                                let sidebarLabel = 'Menu';

                                return (
                                    <Route
                                        key={index}
                                        path={route.path}
                                        exact={route.exact}
                                        component={() => <span>{sidebarLabel}</span>}
                                    />
                                );
                            } else {
                                return (
                                    <Route
                                        key={index}
                                        path={route.path}
                                        exact={route.exact}
                                        component={route.sidebar}
                                    />
                                );
                            }
                        })}
                    </Switch>
                    <Icon>menu</Icon>
                </Button>
                <Drawer anchor="right" open={this.props.layout.navigationDrawerOpen} onClose={this.toggleDrawer('navigation', false)} id="navigation-drawer" className="header-drawer" classes={{
                    paper: 'header-drawer-paper full',
                }}>
                    <div
                        tabIndex={0}
                        role="button"
                        onClick={this.toggleDrawer('navigation', false)}
                        onKeyDown={this.toggleDrawer('navigation', false)}
                    >
                        {menuItems}
                    </div>
                </Drawer>
            </div>
        );
    }
}

HeaderNavigation.propTypes = {
    auth: PropTypes.object.isRequired,
    layout: PropTypes.object.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
    switchDrawer: PropTypes.func.isRequired,
    signoutUser: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    layout: state.layout,
});

export default withRouter(connect(mapStateToProps, {toggleDrawer, switchDrawer, signoutUser})(withLocalize(HeaderNavigation)));



// WEBPACK FOOTER //
// ./src/features/Layout/components/HeaderNavigation.js